export function getRequestId() {
  try {
    return crypto.randomUUID()
  }
  catch {
    return `${new Date().getTime()}-${Math.round(Math.random() * 100)}`
  }
}
